"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// CORE
const react_1 = __importStar(require("react"));
const am4core = __importStar(require("@amcharts/amcharts4/core"));
const am4charts = __importStar(require("@amcharts/amcharts4/charts"));
const classnames_1 = __importDefault(require("classnames"));
// MUI
const mui_1 = require("tss-react/mui");
const react_2 = require("@emotion/react");
const styles_1 = require("@mui/material/styles");
const RendersCount_1 = __importDefault(require("components/RendersCount"));
const AmountField_1 = require("components/QuickenControls/AmountField");
const useXYChart_1 = __importDefault(require("hooks/useXYChart"));
const compose_1 = __importDefault(require("utils/compose"));
const reactRenderToStaticHTML_1 = require("utils/reactRenderToStaticHTML");
const styles_2 = __importDefault(require("./styles"));
const BarChart = (0, react_1.forwardRef)(({ data, height, orderedFields, stacked, onBarSelect, overrideColors, chartId, withLegend, fallbackSelect, compactTooltip, targetLine, alwaysShowTargetLine, monthlyAverage, customDateText, inactiveColor, archived, defaultColors, showScrollBar, noOfMonths, adjustValueAxisScale, currency, classes, showGrid = false, showAxis = false, }, ref) => {
    const { chart, xAxis, yAxis, makeSelectionStates, buildTooltipSeriesInfo, buildTooltipOn, buildLegend, createCategoryRange, } = (0, useXYChart_1.default)(chartId, null, showScrollBar, noOfMonths, withLegend);
    if (chart === null || chart === void 0 ? void 0 : chart.logo) {
        chart.logo.disabled = true;
    }
    const theme = (0, styles_1.useTheme)();
    const rangeColor = theme.palette.status.attentionMain;
    const colors = (0, react_1.useMemo)(() => overrideColors || theme.palette.data.sequence1.map((color) => am4core.color(color)), [overrideColors, theme]);
    const handleCategoryClick = (0, react_1.useCallback)((e, forceSelect = false) => {
        var _a, _b, _c, _d;
        const clickedCat = ((_b = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.dataItem) === null || _b === void 0 ? void 0 : _b.category) || ((_d = (_c = e === null || e === void 0 ? void 0 : e.target) === null || _c === void 0 ? void 0 : _c.dataItem) === null || _d === void 0 ? void 0 : _d.categoryX) || e;
        if (!clickedCat || typeof clickedCat !== 'string' || !chart) {
            return;
        }
        let selectedCat = null;
        chart.series.each((ser) => ser.columns.each((col) => {
            if (selectedCat)
                return;
            if (col.isActive) {
                selectedCat = col.dataItem.categoryX;
            }
        }));
        if (clickedCat === selectedCat && !forceSelect) { // deselecting
            chart.series.each((series) => {
                series.columns.each((paramCol) => {
                    const col = paramCol; // to appease es-lint
                    col.setState(col.dataItem.valueY < 0 ? 'negativeActive' : 'default');
                    col.isActive = false;
                    col.tooltip.hide();
                });
            });
        }
        else { // selecting
            chart.series.each((series) => {
                series.columns.each((paramCol) => {
                    const col = paramCol; // for es-lint
                    if (col.dataItem.categoryX !== clickedCat) {
                        col.isActive = false;
                        col.tooltip.hide();
                    }
                    const isActive = (col.dataItem.categoryX === clickedCat);
                    if (isActive) {
                        col.isActive = true;
                        col.setState(col.dataItem.valueY <= 0 ? 'negativeActive' : 'active');
                    }
                    else {
                        col.setState(col.dataItem.valueY <= 0 ? 'negativeInactive' : 'inactive');
                    }
                    col.tooltip.zIndex = isActive ? 5 : 10;
                });
            });
        }
        onBarSelect(clickedCat === selectedCat && !forceSelect ? null : clickedCat);
    }, [chart, onBarSelect]);
    const checkForFallbackSelect = (0, react_1.useCallback)(() => {
        if (fallbackSelect && fallbackSelect.current) {
            handleCategoryClick(fallbackSelect.current, true);
        }
    }, [fallbackSelect, handleCategoryClick]);
    const createSeries = (0, react_1.useCallback)((field, name, color, withTooltip = false) => {
        const series = chart.series.push(new am4charts.ColumnSeries());
        series.name = name;
        series.dataFields.valueY = field;
        series.dataFields.categoryX = 'category';
        series.showOnInit = false;
        // currently for passing custom value to the second part of the tooltip
        series.dataFields.custom = 'custom';
        // series.sequencedInterpolation = true;  // breaks the y axis
        series.stacked = stacked || false;
        series.columns.template.width = am4core.percent(85);
        if (alwaysShowTargetLine && (-Number(monthlyAverage)) < Number(targetLine))
            yAxis.max = targetLine;
        const cornerRadiusLastSeries = (sign) => (radius, item) => {
            // Find the last series in this stack
            let lastSeries;
            chart.series.each((ser) => {
                if (!ser.isHidden && !ser.isHiding && Math.sign(item.dataItem.dataContext[ser.dataFields.valueY]) === sign) {
                    lastSeries = ser;
                }
            });
            // If current series is the one, use rounded corner
            return item.dataItem.component === lastSeries ? 4 : radius;
        };
        const cornerRadius = (sign) => (radius, item) => Math.sign(item.dataItem.dataContext[series.dataFields.valueY]) === sign ? 4 : radius;
        series.columns.template.column.adapter.add('cornerRadiusTopLeft', stacked ? cornerRadiusLastSeries(1) : cornerRadius(1));
        series.columns.template.column.adapter.add('cornerRadiusTopRight', stacked ? cornerRadiusLastSeries(1) : cornerRadius(1));
        series.columns.template.column.adapter.add('cornerRadiusBottomLeft', stacked ? cornerRadiusLastSeries(-1) : cornerRadius(-1));
        series.columns.template.column.adapter.add('cornerRadiusBottomRight', stacked ? cornerRadiusLastSeries(-1) : cornerRadius(-1));
        series.columns.template.column.zIndex = 2;
        series.columns.template.cursorOverStyle = am4core.MouseCursorStyle.pointer;
        series.columns.template.propertyFields.alwaysShowTooltip = 'hover';
        series.columns.template.tooltipY = 0;
        series.columns.template.tooltipX = stacked ? -50 : -60;
        series.columns.template.fill = color;
        series.columns.template.stroke = color;
        if (stacked)
            series.columns.template.strokeWidth = 0;
        series.fill = am4core.color(color);
        series.columns.template.events.on('hit', handleCategoryClick);
        series.events.on('ready', checkForFallbackSelect);
        series.columns.template.maxWidth = 125;
        if (defaultColors) {
            const createNegativeState = (stateName, stateColor) => {
                const state = series.columns.template.states.create(stateName);
                state.properties.fill = stateColor;
                state.properties.stroke = stateColor;
            };
            createNegativeState('negativeActive', defaultColors[1]);
            createNegativeState('negativeInactive', defaultColors[1].lighten(0.6));
            series.columns.template.propertyFields.fill = 'defaultStateFill';
            series.columns.template.propertyFields.stroke = 'defaultStateFill';
        }
        makeSelectionStates(series.columns.template, color, inactiveColor, !defaultColors);
        // tooltip
        if (withTooltip) {
            buildTooltipOn(series.columns.template);
            series.columns.template.tooltip.dx = compactTooltip ? 40 : 60;
            series.columns.template.tooltip.background.pointerLength = 12;
            let listOfSeriesHTML = '';
            chart.series.each((item) => {
                listOfSeriesHTML += buildTooltipSeriesInfo(item, compactTooltip, false, '', withLegend);
            });
            series.adapter.add('tooltipHTML', (_, target) => {
                const graphData = target.tooltipDataItem.dataContext;
                if (graphData) {
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    const { category, timeStamp, totalValues, txns } = graphData, otherCategories = __rest(graphData, ["category", "timeStamp", "totalValues", "txns"]);
                    let total = 0;
                    let listOfSeriesHTMLCopy = listOfSeriesHTML;
                    Object.keys(otherCategories).forEach((categoryItem) => {
                        total += otherCategories[categoryItem];
                        const categoryName = `{${categoryItem}}`;
                        listOfSeriesHTMLCopy = listOfSeriesHTMLCopy.replace(`$${categoryName}`, (0, AmountField_1.formatNumber)(otherCategories[categoryItem], currency, '0,000.00'));
                    });
                    return (0, reactRenderToStaticHTML_1.reactRenderToStaticHTML)(<div className={classes.barChartTooltipWrapper}>
              <div className={(0, classnames_1.default)(classes.barChartTooltipDate, customDateText ? null : classes.barChartTooltipDateMargin)} id="tooltip_date">
                {customDateText ? 'custom' : category}
              </div>
              {/* eslint-disable-next-line react/no-danger */}
              <div dangerouslySetInnerHTML={{ __html: listOfSeriesHTMLCopy }}/>
              <div className={(0, classnames_1.default)(classes.barChartTooltopLineSeparator, name === 'total' ? classes.barChartTooltopLineSeparatorBorderWidthZero : classes.barChartTooltopLineSeparatorBorderWidth)}/>
              {name !== 'total' &&
                            <div className={classes.barChartTooltipTotal}>
                  <span> Total </span>
                  <span id="tooltip_total_amount">
                    {(0, AmountField_1.formatNumber)(total, currency, '0,000.00')}
                  </span>
                </div>}
            </div>, theme);
                }
                return '';
            });
        }
        series.tooltip.getFillFromObject = false;
        series.tooltip.background.fillOpacity = 0.9;
        series.tooltip.background.fill = am4core.color(theme.palette.background.paper);
        series.tooltip.background.strokeWidth = 0;
        series.tooltip.background.cornerRadius = theme.shape.borderRadius * 2;
        series.tooltip.pointerOrientation = 'vertical';
        return series;
    }, [chart, stacked, makeSelectionStates, checkForFallbackSelect, buildTooltipOn, buildTooltipSeriesInfo,
        handleCategoryClick, theme, compactTooltip, customDateText, inactiveColor, alwaysShowTargetLine, monthlyAverage,
        targetLine, yAxis, defaultColors, withLegend, classes, currency]);
    (0, react_1.useLayoutEffect)(() => {
        var _a;
        if (chart && !chart.isDisposed() && orderedFields) { // this is where to set up chart specific stuff
            xAxis.renderer.cellStartLocation = 0.2;
            xAxis.renderer.cellEndLocation = 0.8;
            (_a = chart === null || chart === void 0 ? void 0 : chart.series) === null || _a === void 0 ? void 0 : _a.clear();
            chart.invalidateData();
            orderedFields === null || orderedFields === void 0 ? void 0 : orderedFields.forEach((field, i) => createSeries(field, field, colors[i], i === Math.min(orderedFields.length - 1, 4)));
            chart.data = defaultColors ? data.map((dataItem) => (Object.assign(Object.assign({}, dataItem), { defaultStateFill: dataItem.total > 0 ? defaultColors[0] : defaultColors[1] }))) : data;
            chart.numberFormatter.numberFormat = '#,###.00';
            buildLegend();
            // handles clicking the category labels to put the other bars in an unselected state
            xAxis.renderer.labels.template.events.on('hit', handleCategoryClick);
            xAxis.axisRanges.clear();
            yAxis.axisRanges.clear();
            // override the default value of yaxis min/max to show the value from zero.
            if (adjustValueAxisScale) {
                const amountList = data === null || data === void 0 ? void 0 : data.map(({ total }) => total);
                const monthlyMinAmount = amountList ? Math.min(...amountList) : 0;
                const monthlyMaxAmount = amountList ? Math.max(...amountList) : 0;
                yAxis.min = monthlyMinAmount < 0 ? monthlyMinAmount : 0;
                yAxis.max = monthlyMinAmount < 0 && monthlyMaxAmount < 0 ? 0 : monthlyMaxAmount;
            }
            data.forEach(({ category }) => {
                const catRange = createCategoryRange(category);
                catRange.axisFill.events.on('hit', handleCategoryClick);
                catRange.axisFill.cursorOverStyle = am4core.MouseCursorStyle.pointer;
            });
            if (targetLine) {
                // Create value axis range
                const range = yAxis.axisRanges.create();
                range.value = targetLine;
                range.grid.fill = am4core.color(theme.palette.text.strong);
                range.grid.strokeWidth = 1;
                range.grid.strokeOpacity = 0.7;
                range.label.text = `${(0, AmountField_1.formatNumber)(parseFloat(`${targetLine}`), currency, '0,0', false)}`;
                range.label.background.fill = am4core.color(theme.palette.text.strong);
                range.label.fill = am4core.color(theme.palette.background.paper);
                range.grid.above = true;
            }
            if (showGrid) {
                xAxis.renderer.grid.template.disabled = false;
                yAxis.renderer.grid.template.disabled = false;
            }
            if (showAxis) {
                xAxis.renderer.line.strokeOpacity = 1;
                yAxis.renderer.line.strokeOpacity = 1;
            }
            if (archived) {
                chart.series.each((series) => {
                    series.columns.each((paramCol) => {
                        const col = paramCol; // to appease es-lint
                        col.setState('archived');
                        col.isActive = false;
                        col.tooltip.hide();
                    });
                });
            }
            chart.events.on('validated', () => {
                setTimeout(() => {
                    if (yAxis && !yAxis.isDisposed()) {
                        yAxis.zoom({ start: 0, end: 1 }, false, true);
                    }
                }, 1500);
            });
        }
    }, [orderedFields, createSeries, chart, buildLegend, createCategoryRange, colors, theme, xAxis, data,
        handleCategoryClick, yAxis, withLegend, targetLine, archived, rangeColor, defaultColors, showAxis, showGrid, adjustValueAxisScale, currency]);
    const divStyle = (0, react_1.useMemo)(() => ({ width: '100%', height: height || 400 }), [height]);
    (0, react_1.useImperativeHandle)(ref, () => ({
        getGraphImage() {
            var _a;
            return (_a = chart === null || chart === void 0 ? void 0 : chart.exporting) === null || _a === void 0 ? void 0 : _a.getImage('png', { quality: 1, scale: 3 });
        },
    }));
    return (<>
      <RendersCount_1.default id="newReportsBarChart"/>
      <div id={chartId} style={divStyle}/>
    </>);
});
exports.default = (0, compose_1.default)(react_2.withTheme)((0, mui_1.withStyles)(BarChart, styles_2.default));
